<script>
import axios from 'axios'
import AiTutor from './AiTutor.vue';

export default {
    components: {
        AiTutor
    },
    data() {
        const { token, lang, grade, context } = this.getParamsFromUrl();

        this.$i18n.locale = lang;

        return {
            user_info: null,
            token,
            grade,
            metadata: context
        };
    },
    computed: {
        fullname() {
            return this.user_info?.fullname || '';
        },
        username() {
            return this.user_info?.username || '';
        },
        config() {
            return this.user_info?.package_features?.find(feature => feature?.feature_code === 'ai_home_tutor');
        },
    },
    mounted() {
        this.getUserInfo();
    },
    methods: {
        async getUserInfo() {
            if (!this.token) {
                console.error('Missing token.');
                return;
            }

            const res = await axios.get(`${process.env.VUE_APP_API_URL}/user/info`, {
                headers: {
                    Authorization: `Bearer ${this.token}`
                }
            });
            const result = res?.data?.results;
            if (!result) return;

            this.user_info = result;
        },

        getParamsFromUrl() {
            const token = this.$route.query.token;
            const lang = this.$route.query.lang || 'vi';
            const grade = this.$route.query.grade;
            const ctxRaw = this.$route.query.context;

            let context = null;
            if (ctxRaw) {
                try {
                    context = JSON.parse(decodeURIComponent(ctxRaw));
                } catch (e) {
                    console.warn('Invalid context JSON:', e);
                }
            }

            return { token, lang, grade, context };
        }
    }
}
</script>

<template>
    <ai-tutor v-if="config" :config="config" :fullname="fullname" :username="username" :grade="grade"
        :metadata="metadata" :fullscreen="true" />
</template>